export default [
    {
        comment: '',
        error_id: 'ST 06',
        data: [
            {
                "cross_section": "42127",
                "us_name": "42157",
                "ds_name": "42062",
                "type": "Culvert",
                "profiles": [
                    "FW",
                    "100yr (1%)"
                ]
            }
        ]
    },
]